import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StepContainer = styled.div<{
  $active: boolean;
}>`
  display: flex;
  padding: 9px;
  align-items: center;
  border-radius: 50%;
  border: 2px solid
    ${({ $active }) =>
      $active ? 'var(--border-primary)' : 'var(--border-disabled)'};
`;

export const DottedLine = styled.div<{ $active: boolean }>`
  min-width: 36px;
  flex-grow: 1;
  border-bottom: 2px dotted
    ${({ $active }) =>
      $active ? 'var(--border-primary)' : 'var(--border-disabled)'};
`;

export const Connector = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;

  ${({ $active }) =>
    $active
      ? `
   border: 1px solid var(--border-primary);
   background: var(--action-primary-soft-hover);
   color: var(--text-primary);
  `
      : `
   border: 1px solid var(--border-disabled);
   background: var(--background-default);
   color: var(--text-disabled);
  `}
`;

export const StepLogo = styled.img<{ $size: number; $color?: string }>`
  min-width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-color: ${({ $color }) => $color ?? 'var(--surface-inverse)'};
`;

export const FallbackLogo = styled.div<{
  $size: number;
  $active: boolean;
}>`
  cursor: default;
  min-width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background-color: ${({ $active }) =>
    $active ? 'var(--icon-decorative-blue)' : 'var(--surface-default)'};
  display: flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: var(--text-default);
  ${typographyV2.titleSm}
`;

export const CustomLogo = styled.div<{ $size: number }>`
  min-width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
